import { AuthsApi } from '@api';
import { Card, Center, Text } from '@chakra-ui/react';
import { Alert, InfoTip, OverlayDialog, PinInput, toasterApi } from '@ui';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { safeInternalPath } from '@/utils/safeNext';

const MfaAuthentication: React.FC = () => {
  const [code, setCode] = useState<string>();
  const [postMFAVerify] = AuthsApi.Api.usePostMFAVerifyMutation();

  const navigate = useNavigate();
  const location = useLocation();

  const verifyMFA = async () => {
    const { data, error } = await postMFAVerify(code!);
    if (data) {
      OverlayDialog.close("mfaVerfication");

      toasterApi({
        type: "success",
        status: 200,
        code: "Success",
        message: `MFA Authenticated`,
      });

      // Navigation logic: if on login page, continue to the requested page, else refresh current page
      if (location.pathname === '/login') {
        const next = new URLSearchParams(location.search).get('next');
        navigate(safeInternalPath(next) ?? '/', { replace: true });
      } else {
        // Refresh the current page
        window.location.reload();
      }
    }
  };

  useEffect(() => {
    if (!code) return;
    verifyMFA();
  }, [code]);

  return (
    <Card.Root width="100%" variant="elevated" flexDirection="row">
      <Card.Body flexDirection="column" gap="5">
        <Text textStyle="heading.card" color="secondary.fg">
          MFA Authentication{" "}
          <InfoTip size="lg">
            <Alert>
              <b>Enter the code from your authenticator app to login.</b>
            </Alert>
          </InfoTip>
        </Text>
        <Center flexDirection="column" gap={10}>
          <Text>Enter the code from your authenticator app to login.</Text>
          <PinInput
            attached
            count={6}
            onPinComplete={(value) => {
              setCode(value);
            }}
          />
        </Center>
      </Card.Body>
    </Card.Root>
  );
};

export default MfaAuthentication;
